var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.36 35.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #65afd3;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.77,16.01c0,2.46.23,4.71,1.14,6.84-2.6-1.5-5.33-2.28-8.56-2.28l-2.51.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.25,12.41c.22,1.11.35,2.44.35,3.61,0,2.46-.23,4.71-1.14,6.84,2.46-1.43,5.05-2.2,8.05-2.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,12.36c.99-4.26,3.73-9.28,7.18-11.74,2.51,1.8,4.54,5.16,5.84,8.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.74,14.24c-.16.95-.24,1.92-.24,2.92,0,9.76,7.92,17.68,17.68,17.68s17.68-7.92,17.68-17.68c0-2.15-.38-4.21-1.09-6.11-.76-.1-1.54-.16-2.34-.16-5.85,0-11.04,2.85-14.26,7.23-3.22-4.38-8.4-7.23-14.26-7.23-.79,0-1.57.06-2.34.16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.dc051ec2bfd3c5f79e81b7c104f068da.svg";
export { ForwardRef as ReactComponent };